// @flow
import React from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './LabeledIconsList.themes';

export type LabeledIcon = {
  icon: IconName,
  labels: Array<string>,
};

type Props = {
  className?: string,
  color?: Colors,
  items: Array<LabeledIcon>,
  theme?: string,
};

export function LabeledIconsList(props: Props) {
  const { color = COLORS.BLUE, className, items = [], theme = 'default' } = props;

  if (!items.length) {
    return null;
  }

  const { thIcon, thIconWidth, thItem, thItemNth, thLabels, thRoot } = themes[theme];

  const classes = classnames(className, `text-${color}`, thRoot);

  return (
    <ul className={classes}>
      {items.map(({ icon, labels }, idx) => {
        return (
          <li className={classnames(thItem, { [thItemNth]: idx > 0 })} key={idx}>
            <div className={thIcon}>
              <Icon name={icon} width={thIconWidth} alt={(labels || []).join('/')} />
            </div>
            {labels ? (
              <div className={thLabels}>
                {labels.map(label => (
                  <div data-testid="LabeledIconsList-label" key={label}>
                    {label}
                  </div>
                ))}
              </div>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
